<template>
	<div class="home">
		<!-- <router-view /> -->
		<div class="head">
			<p class="one">数据统计-首页</p>
			<p class="two" @click="shuaxin">刷新</p>
		</div>
		<div class="head1">
		 <Date-picker type="date" v-model="date1" format="yyyy-MM-dd" @on-change="searchAllUser" placeholder="请选择日期" style="width: 200px"></Date-picker>
			<div class="head-cont">
				<p style="margin-left:20px">新增用户：</p>
				<p>{{newAddUser}}</p>
			</div>
			<div class="head-cont">
				<p style="margin-left:20px">累计用户：</p>
				<p>{{CumulativeUser}}</p>
			</div>
			<div class="head-cont">
				<p style="margin-left:20px">扫码数：</p>
				<p>{{scanNumber}}</p>
			</div>
		</div>
		<div class="head2">
			<Select v-model="model1" @on-change="choseSF" size="large" placeholder="请选择省份" style="width:150px">
        <Option v-for="item in cityList1" :value="item.id" :key="item.id">{{ item.name }}</Option>
    	</Select>
			<Select v-model="model2" @on-change="choseSHI" size="large" placeholder="请选择市" style="width:150px">
        <Option v-for="item in shi" :value="item.id" :key="item.id">{{ item.name }}</Option>
    	</Select>
			<Select v-model="model3" @on-change="choseQU" size="large" placeholder="请选择区" style="width:150px">
        <Option v-for="item in qu" :value="item.id" :key="id">{{ item.name }}</Option>
    	</Select>
			<Select v-model="model4" @on-change="choseCJ" size="large" placeholder="请选择场景" style="width:150px">
        <Option v-for="item in cityList4" :value="item.value" :key="item">{{ item.label }}</Option>
    	</Select>
			<Select v-model="model5" @on-change="choseYYS" v-if="typeId == 2" size="large" placeholder="请选择运营商" style="width:150px">
        <Option v-for="item in cityList5" :value="item.id" :key="item.id">{{ item.companyName }}</Option>
    	</Select>
			<Select v-model="model7" v-if="typeId == 2" @on-change="chosePTSB" size="large" placeholder="请选择设备" style="width:150px">
        <Option v-for="item in cityList7" :value="item.id" :key="item.id">{{ item.macDetailsName }}-ID{{item.id}}</Option>
    	</Select>
			<Select v-model="model6" v-else @on-change="choseSB" size="large" placeholder="请选择设备" style="width:150px">
        <Option v-for="item in cityList6" :value="item.id" :key="item.id">{{ item.macDetailsName }}-ID{{item.id}}</Option>
    	</Select>
			<Date-picker :value="value2" @on-change="choseDate" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;"></Date-picker>
		</div>
		<!-- echarts图形 -->
		<div style="width:100%;margin-top: 20px;display: flex;">
			<div id="first-echart" style="width: 600px;height: 400px;"></div>
			<div id="second-echart" style="width: 600px;height: 400px;"></div>
		</div>
		<div style="width:100%;margin-top: 20px;display: flex;">
			<div id="third-echart" style="width: 890px;height: 400px;margin-left: -80px;"></div>
			<div id="four-echart" style="width: 510px;height: 400px;margin-left:0px;"></div>
		</div>
	</div>
</template>
<script>
import * as echarts from 'echarts';
import http from '../../http/http.js'
	export default {
		
		data() {
			return {
				date1:'',
				newAddUser:0,
				CumulativeUser:0,
				scanNumber:0,
				model1:'',
				model2:'',
				model3:'',
				model4:'',
				model5:'',
				model7:'',
				model6:'',
				value2:['2021-2-3','2021-2-6'],
				cityList1:[],
				shi:[],
				qu:[],
				cityList4:[],
				cityList5:[],
				cityList6:[],
				cityList7:[],
				query1:{
					date:''
				},
				query2:{
					regionId:'',
					operId:'',
					macId:'',
					beginDate:'',
					overDate:'',
					sceneId:''
				},
				query3:{
					regionId:'',
					operId:'',
					macId:'',
					beginDate:'',
					overDate:'',
					sceneId:''
				},
				query4:{
					regionId:'',
					operId:'',
					macId:'',
					beginDate:'',
					overDate:'',
					sceneId:''
				},
				query5:{
					regionId:'',
					operId:'',
					macId:'',
					beginDate:'',
					overDate:'',
					sceneId:''
				},
				query6: {//运营商查询参数
					page: 0,
					size: 100,
					like:''
				},
				query7: {
					page: 0,
					size: 100,
					id: '' ,//加盟商id
					like:'',
					macKind:'',
					regionId:'',
					startUsing:'',
					state:'',
				},
				operId:'',
				typeId:''
			}
		},
		created(){
			var time = new Date();
			let year = time.getFullYear(); //获取年 
			let month = time.getMonth() + 1;//获取月  
			let day = time.getDate()
			if(month<10) {
				month = '0' + month
			}
			if(day<10) {
				day = '0' + day
			}
			let nowTime = year + '-' + month + '-' +day
			this.date1 = nowTime
			this.searchAllUser1()
			console.log(nowTime,'实时时间')
			var date = new Date();
			date.setDate(date.getDate() - 2);//获取3天前的日期
			var year1 = date.getFullYear();
			var month1 = date.getMonth() + 1;
			var day1 = date.getDate();
			if(month1<10) {
				month1 = '0' + month1
			}
			if(day1<10) {
				day1 = '0' + day1
			}
			var time1 = year1 + "-" + month1 + "-" + day1;
			console.log(time1,'time1')
			this.value2[0] = time1
			this.value2[1] = nowTime
			console.log(this.value2,'this.value2')
			this.query2.beginDate = this.value2[0]
			this.query2.overDate = this.value2[1]
			this.query3.beginDate = this.value2[0]
			this.query3.overDate = this.value2[1]
			this.query4.beginDate = this.value2[0]
			this.query4.overDate = this.value2[1]
			this.query5.beginDate = this.value2[0]
			this.query5.overDate = this.value2[1]




			let users = sessionStorage.getItem('user')
			let users1 = JSON.parse(users)
			this.operId = users1.operId
			this.typeId = users1.type
			console.log(this.typeId,'typeId')
			this.query2.operId = this.operId
			this.query3.operId = this.operId
			this.query4.operId = this.operId
			this.query5.operId = this.operId
			// 查询省份
			this.queryProvince()
			// 查询设备
			this.queryEquipment()
			//进页面默认查询销售金额折线图
			this.queryAmountChart()
			// 进页面默认查询销售订单数量折线图
			this.querySalesOrder()
			// 进页面默认查询商品数量饼状图
			this.queryCommodity()
			// 进页面默认查询流量漏斗图
			this.queryFlowFunnel()
			// 进页面查询运营商
			this.quaryOperator()
			// 进页面查询平台管理员账号设备
			this.queryPlatformEquipment()
		},
		inject:['refresh'],
		methods:{
			// 选择平台管理员账号设备
			chosePTSB(){
				this.query2.macId = this.model7
				this.query3.macId = this.model7
				this.query4.macId = this.model7
				this.query5.macId = this.model7
				this.queryAmountChart()
				this.querySalesOrder()
				this.queryCommodity()
				this.queryFlowFunnel()
			},
			// 查询平台管理员账号设备
			queryPlatformEquipment(){
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/page/jm/allianceAll',
					data:this.query7,
					success: (data)=> {
						console.log(data,'查询平台管理员账号设备')
						this.cityList7 = data.macLeaveFactorys.content
					}
				  })
			},
			// 选择运营商
			choseYYS(){
				// console.log(this.model5,'this.model5')
				this.query2.operId = this.model5
				this.query3.operId = this.model5
				this.query4.operId = this.model5
				this.query5.operId = this.model5
				this.queryAmountChart()
				this.querySalesOrder()
				this.queryCommodity()
				this.queryFlowFunnel()
			},
			// 查询运营商
			quaryOperator(){
				http.http({
				    //这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/plat/oper/page',
					data: this.query6,
					success: (data)=> {
					// console.log(data,"查询运营商")
					this.cityList5 = data.opers.content
				}
				})
			},
			// 刷新
			shuaxin(){
				// console.log('刷新页面')
				this.refresh()
			},
			// 查询流量漏斗图
			queryFlowFunnel(){
				http.http({
					url:http.url + '/home/statistics/query5',
					method:'post',
					data:this.query5,
					success:(res)=>{
						// console.log(res,'查询流量漏斗')
						if(res.code == 200) {
							let newData1 = [{value:'',name:'完成付款'}]
							let newData2 = [{value:'',name:'正常订单'}]
							let newData3 = [{value:'',name:'进入小捷智购'}]
							newData1[0].value = res.data.count1
							newData2[0].value = res.data.count2
							newData3[0].value = res.data.count3
							let allData = newData1.concat(newData2).concat(newData3)
							// console.log(allData,'allData')
      				var myChart3 = echarts.init(document.getElementById('four-echart'));
							const option3 = {
								title:{
										text:'流程漏斗图'
								},
								// tooltip: {
								// 	// trigger: 'item',
								// 	formatter:'{b}:{c}'
								// },
								series: [
									{
										name:'漏斗图',
										type:'funnel',
										left: '10%',
										color:['#1890FF','#40A9FF','#0050B3'],
										top: 60,
										//x2: 80,
										bottom: 60,
										width: '50%',
										// height: {totalHeight} - y - y2,
										min: 0,
										max: 100,
										// minSize: '0%',
										maxSize: '100%',
										minSize: '20%',              //每一块的最小宽度
										maxSize:'90%',               //每一块的最大快递   一次去除掉尖角
										sort: 'descending',
										gap: 1,                //每一块之间的间隔
										// label: {            //设置每一块的名字是显示在图里面还是外面
										//     show: true,
										//     position: 'inside'
										// },
										// label: {
										// 	show: true,
										// 	normal:{
										// 		formatter:'{b}:{c}'
										// 	},
										// },
										labelLine: {           
												length: 100,             //设置每一块的名字前面的线的长度
												lineStyle: {
														width: 1,         //设置每一块的名字前面的线的宽度
														type: 'solid'    //设置每一块的名字前面的线的类型
												}
										},
										itemStyle: {
												normal: { 
														borderColor: '#fff',        //每一块的边框颜色
														borderWidth: 0,             //每一块边框的宽度
														// shadowBlur: 50,             //整个外面的阴影厚度
														shadowOffsetX: 0,
														// shadowOffsetY: 50,          //每一块的x轴的阴影
														shadowColor: 'rgba(0, 0, 0, 0.5)'  ,  //阴影颜色
														label:{
															show:true,
															position:'outside',
															formatter:'{b}:{c}'
														}
												}
										},
										emphasis: {
												label: {
														fontSize: 20
												}
										},
										data: allData
									},
									{
										name:'漏斗图',
										type:'funnel',
										left: '10%',
										color:['#0050B3','#1890FF','#40A9FF'],
										top: 60,
										//x2: 80,
										bottom: 60,
										width: '50%',
										// height: {totalHeight} - y - y2,
										min: 0,
										max: 100,
										// minSize: '0%',
										maxSize: '100%',
										minSize: '20%',              //每一块的最小宽度
										maxSize:'90%',               //每一块的最大快递   一次去除掉尖角
										sort: 'descending',
										gap: 1,                //每一块之间的间隔
										// label: {            //设置每一块的名字是显示在图里面还是外面
										//     show: true,
										//     position: 'inside'
										// },
										// label: {
										// 	show: true,
										// 	normal:{
										// 		formatter:'{b}:{c}'
										// 	},
										// },
										labelLine: {           
												length: 100,             //设置每一块的名字前面的线的长度
												lineStyle: {
														width: 1,         //设置每一块的名字前面的线的宽度
														type: 'solid'    //设置每一块的名字前面的线的类型
												}
										},
										itemStyle: {
												normal: { 
														borderColor: '#fff',        //每一块的边框颜色
														borderWidth: 0,             //每一块边框的宽度
														// shadowBlur: 50,             //整个外面的阴影厚度
														shadowOffsetX: 0,
														// shadowOffsetY: 50,          //每一块的x轴的阴影
														shadowColor: 'rgba(0, 0, 0, 0.5)'  ,  //阴影颜色
														label:{
															show:true,
															position:'inner',
															formatter:'{d}%'
														}
												}
										},
										emphasis: {
												label: {
														fontSize: 20
												}
										},
										data: allData
									}
								]
							}
							myChart3.setOption(option3) //指定的配置项和数据显示图表
						}
					}
				})
			},
			// 查询商品数量饼状图
			queryCommodity(){
				http.http({
					url:http.url + '/home/statistics/query4',
					method:'post',
					data:this.query4,
					success:(res)=>{
						// console.log(res,'查询商品数量123')
						if(res.code == 200) {
							const newData = res.data.map(v=>{
								return{
									value:v.number,
									name:v.name
								}
							})
							// console.log(newData,'newData')
      				var myChart2 = echarts.init(document.getElementById('third-echart'));
							const option2 = {
								legend: {
									orient : '',
									// orient : 'vertical',
									x : 'right',
									// bottom:200,
									top:100,
									// left:0,
									right:50,
									itemWidth: 10,//标志图形的长度
									itemHeight: 10,//标志图形的宽度
									icon: 'circle',
								},
								title:{
									text:'商品销量TOP10饼状图',
									left:100
								},
								calculable : true,  
								series : [
									{
										name: '商品销量TOP10饼状图',
										type: 'pie',
										data: newData,
										color:['#1890FF','#13C2C2','#2FC25B','#FACC14','#F04864','#8543E0','#3436C7','#223273','red','black'],
										// itemStyle: { color: '#FFBD1C'},
										label: {
											show: true,
											normal:{
												formatter:'{b}:{d}%',
												// formatter: '{b} : {c} ({d}%)'  //展示的文字   类型+百分比
												// formatter:function(data){ 
												// 	console.log(data,"叽叽喳喳数据")
												// 	return data.percent.toFixed(1)+"%";
												// } 
											}
										},
									}
								]
						};
						myChart2.setOption(option2) //指定的配置项和数据显示图表
						}
					}
				})
			},
			// 查询销售订单数量折线图
			querySalesOrder(){
				http.http({
					url:http.url + '/home/statistics/query3',
					method:'post',
					data:this.query3,
					success:(res)=>{
						// console.log(res,'查询销售数量')
						if(res.code == 200) {
							var myChart1 = echarts.init(document.getElementById('second-echart'));
							const option1 = {
								tooltip : {
										trigger: 'axis',
										axisPointer: {
											type: 'cross',
											label: {
												backgroundColor: '#6a7985'
										}
									}
								},
								xAxis:{ //X轴
									show:true,
									type:'category', //类目名称
									boundaryGap: false,
									name:"(时间)",
									axisLabel:{
										
									},
									data: res.data.times
								},
								yAxis:{  //y轴
										type:'value', //数值轴
										axisLabel:{
											formatter:'{value}'
										},
										// splitNumber: 6,
								},
								grid: {
									// left: '3%',
									// right: '4%',
									// bottom: '3%',
									// containLabel: true
								},
								lineStyle:{
									color:'#1890FF'
								},
								title: {
									text: '订单折线图',
									left: 'left',//title 组件离容器左侧的距离.'left', 'center', 'right'
									top:'top', //title 组件离容器上侧的距离.'top', 'middle', 'bottom'
									textStyle:{
										color:"#000000",
										fontSize:"20",
									}
								},
								series:[
									{
										name:'数量',
										type:'line',
										stack: '总量',
										data: res.data.values,
										symbol: 'circle',
										itemStyle:{
											color:'#1890FF',
											normal: {label:{show: true},color:'#1890FF'}
										}
									}
								]
						}
						myChart1.setOption(option1) //指定的配置项和数据显示图表
						}
					}
				})
			},
			// 查询新增用户，累计用户，扫码次数
			searchAllUser(a){
				this.query1.date = a
				http.http({
					url:http.url + '/home/statistics/query1',
					method:'post',
					data:this.query1,
					success:(res)=>{
						// console.log(res,'查询用户')
						if(res.code == 200) {
							this.newAddUser = res.data.cout2
							this.CumulativeUser = res.data.cout1
							this.scanNumber = res.data.cout3
						}
					}
				})
			},
			searchAllUser1(){
				this.query1.date = this.date1
				http.http({
					url:http.url + '/home/statistics/query1',
					method:'post',
					data:this.query1,
					success:(res)=>{
						// console.log(res,'查询用户')
						if(res.code == 200) {
							this.newAddUser = res.data.cout2
							this.CumulativeUser = res.data.cout1
							this.scanNumber = res.data.cout3
						}
					}
				})
			},
			// 查询省份
			queryProvince(){
				http.http({
					url:http.url + '/region/junior',
					method:'post',
					data:{
						id:'100000'
					},
					success:(res)=>{
						// console.log(res,'查询省份')
						if(res.code == 200) {
							this.cityList1 = res.list
						}
					}
				})
			},
			// 选择省份查询市
			choseSF(){
				// console.log(this.model1,'model1')
				http.http({
					url:http.url + '/region/junior',
					method:'post',
					data:{
						id:this.model1
					},
					success:(res)=>{
						// console.log(res,'查询市')
						if(res.code == 200) {
							this.shi = res.list
						}
					}
				})
			},
			//选择市查询区
			choseSHI(){
				http.http({
					url:http.url + '/region/junior',
					method:'post',
					data:{
						id:this.model2
					},
					success:(res)=>{
						// console.log(res,'查询区')
						if(res.code == 200) {
							this.qu = res.list
						}
					}
				})
			},
			//选择区查询场景
			choseQU(){
				http.http({
					url:http.url + '/region/junior',
					method:'post',
					data:{
						id:this.model3
					},
					success:(res)=>{
						// console.log(res,'查询场景')
						if(res.code == 200) {
							this.cityList4 = res.list
							this.query2.regionId = this.model3
							this.query3.regionId = this.model3
							this.query4.regionId = this.model3
							this.query5.regionId = this.model3
							
							// this.query2.operId = this.operId
							// this.query3.operId = this.operId
							// this.query4.operId = this.operId
							// this.query5.operId = this.operId

							// this.query2.operId = this.model5
							// this.query3.operId = this.model5
							// this.query4.operId = this.model5
							// this.query5.operId = this.model5
							if(this.typeId == 2) {
								this.query2.operId = this.model5
								this.query3.operId = this.model5
								this.query4.operId = this.model5
								this.query5.operId = this.model5
							}else{
								this.query2.operId = this.operId
								this.query3.operId = this.operId
								this.query4.operId = this.operId
								this.query5.operId = this.operId
							}


							this.queryAmountChart()
							this.querySalesOrder()
							this.queryCommodity()
							this.queryFlowFunnel()
						}
					}
				})
			},
			// 选择场景
			choseCJ(){
				this.query2.sceneId = this.model4
				this.query3.sceneId = this.model4
				this.query4.sceneId = this.model4
				this.query5.sceneId = this.model4

				// this.query2.operId = this.operId
				// this.query3.operId = this.operId
				// this.query4.operId = this.operId
				// this.query5.operId = this.operId

				// this.query2.operId = this.model5
				// this.query3.operId = this.model5
				// this.query4.operId = this.model5
				// this.query5.operId = this.model5
				if(this.typeId == 2) {
					this.query2.operId = this.model5
					this.query3.operId = this.model5
					this.query4.operId = this.model5
					this.query5.operId = this.model5
				}else{
					this.query2.operId = this.operId
					this.query3.operId = this.operId
					this.query4.operId = this.operId
					this.query5.operId = this.operId
				}
				this.queryAmountChart()
				this.querySalesOrder()
				this.queryCommodity()
				this.queryFlowFunnel()
			},
			//查询设备
			queryEquipment(){
				http.http({
					url:http.url + '/fac/mac/leave/factory/page/oper',
					method:'post',
					data:{
						page:0,
						size:100,
						like:''
					},
					success:(res)=>{
						// console.log(res,'查询设备')
						if(res.code == 200) {
							this.cityList6 = res.list
						}
					}
				})
			},
			// 选择开始时间和结束时间
			choseDate(a){
				this.query2.beginDate = a[0]
				this.query2.overDate = a[1]
				this.query3.beginDate = a[0]
				this.query3.overDate = a[1]
				this.query4.beginDate = a[0]
				this.query4.overDate = a[1]
				this.query5.beginDate = a[0]
				this.query5.overDate = a[1]

				// this.query2.operId = this.operId
				// this.query3.operId = this.operId
				// this.query4.operId = this.operId
				// this.query5.operId = this.operId

				// this.query2.operId = this.model5
				// this.query3.operId = this.model5
				// this.query4.operId = this.model5
				// this.query5.operId = this.model5
				if(this.typeId == 2) {
					this.query2.operId = this.model5
					this.query3.operId = this.model5
					this.query4.operId = this.model5
					this.query5.operId = this.model5
				}else{
					this.query2.operId = this.operId
					this.query3.operId = this.operId
					this.query4.operId = this.operId
					this.query5.operId = this.operId
				}
				this.queryAmountChart()
				this.querySalesOrder()
				this.queryCommodity()
				this.queryFlowFunnel()
			},
			// 选择设备
			choseSB(){
				this.query2.macId = this.model6
				this.query3.macId = this.model6
				this.query4.macId = this.model6
				this.query5.macId = this.model6
				this.query2.operId = this.operId
				this.query3.operId = this.operId
				this.query4.operId = this.operId
				this.query5.operId = this.operId
				this.queryAmountChart()
				this.querySalesOrder()
				this.queryCommodity()
				this.queryFlowFunnel()
			},
			// 查询金额折线图数据
			queryAmountChart(){
				// this.query2.regionId = this.model3
				// this.query2.macId = this.model6
				http.http({
					url:http.url + '/home/statistics/query2',
					method:'post',
					data:this.query2,
					success:(res)=>{
						// console.log(res,'查询金额')
						if(res.code == 200) {
							var myChart = echarts.init(document.getElementById('first-echart'));
							const option = {
								tooltip : {
									trigger: 'axis',
									axisPointer: {
										type: 'cross',
										label: {
											backgroundColor: '#6a7985'
										}
									}
								},
								xAxis:{ //X轴
									show:true,
									type:'category', //类目名称
									boundaryGap: false,
									name:"(时间)",
									axisLabel:{
										
									},
									data: res.data.times
								},
								yAxis:{  //y轴
										type:'value', //数值轴
										axisLabel:{
											formatter:'{value}'
										},
										// splitNumber: 6,
								},
								grid: {
									// left: '3%',
									// right: '4%',
									// bottom: '3%',
									// containLabel: true
								},
								lineStyle:{
									color:'#1890FF'
								},
								title: {
									text: '金额折线图',
									left: 'left',//title 组件离容器左侧的距离.'left', 'center', 'right'
									top:'top', //title 组件离容器上侧的距离.'top', 'middle', 'bottom'
									textStyle:{
										color:"#000000",
										fontSize:"20",
									}
								},
								series:[
									{
										name:'数量',
										type:'line',
										stack: '总量',
										data: res.data.values,
										symbol: 'circle',
										itemStyle:{
											color:'#1890FF',
											normal: {label:{show: true},color:'#1890FF'}
										}
									}
								]
						}
						myChart.setOption(option) //指定的配置项和数据显示图表
						}
					}
				})
			}
		},
		mounted(){}
		
	}
</script>
<style scoped="scoped" lang="less">
.home{
	.head{
		display: flex;
		align-items: center;
		.one{
			font-size: 24px;
			font-weight: 600;
		}
		.two{
			display: inline-block;
			font-size: 14px;
			border: 1px solid #ccc;
			padding: 0 5px;
			margin-left: 20px;
			cursor: pointer;
		}
	}
	.head1{
		display: flex;
		align-items: center;
		margin-top: 20px;
		.head-cont{
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #333333;
		}
	}
	.head2{
		display: flex;
		align-items: center;
		margin-top: 20px;
		
	}
}
/deep/.ivu-input{
	height: 36px !important;
}
#first-echart{
	width: 500px;
	// height: 200px;
	// background-color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue